import React, { useState, useEffect, useContext } from "react";
import "../css/App.css";
import Header from "../components/Header.js";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
//import { Link } from "react-router-dom";

import Slider from "../components/Slider.js";
import ContenedorTarjetas from "../components/ContenedorTarjetas.js";
import Gastos from "../components/Gastos.js";
import Reserva from "../components/Reserva.js";
import Contacto from "../components/Contacto.js";

import ModalVideo from "../components/ModalVideo.js";

import ResultadoReserva from "../components/ResultadoReserva.js";

import { uiContext } from "../contexts/UiContextProvider";

function App() {
  const urltgm_base = "https://store.autoprana.com.ar/vtf/urltgm/";

  const [modelos, setModelos] = useState([]);
  const [vehiculoSeleccionado, setVehiculoSeleccionado] = useState(null);
  const [gastosSeleccionados, setGastosSeleccionados] = useState(null);
  const [resultadoReserva, setResultadoReserva] = useState(null);
  const [comprobante, setComprobante] = useState(null);

  const [mostrarModal, setMostrarModal] = useState(false);

  /* gastosSeleccionados = {
    "total": "$ 3049000",
    "patentamiento": 0, // 0 con nosotros, 1 por su cuenta
    "total_pat": 256000
} */

  // eslint-disable-next-line no-unused-vars
  const scrollTop = () => {
    window.scroll({
      top: 0,
    });
  };

  const actualizarVehiculoSeleccionado = (vehiculo) => {
    setVehiculoSeleccionado(vehiculo);

    let url_tgm = `${urltgm_base}gastos.php?modelo=${vehiculo.modelo}&version=${vehiculo.version}`;

    fetch(url_tgm);
  };

  const handleOnGastoSeleccionado = (gastos) => {
    setGastosSeleccionados(gastos);
  };

  const handleReservar = (estadoReserva) => {
    setResultadoReserva(estadoReserva);
  };

  const handleComprobante = (numeroComprobante) => {
    setComprobante(numeroComprobante);
  };

  const handleMostrarModal = (state) => {
    setMostrarModal(state);
  };

  useEffect(() => {
    var url = "https://store.autoprana.com.ar/pranaapi/autos/modelos";

    fetch(url)
      .then((data) => {
        return data.json();
      })
      .then((modelos) => {
        setModelos(modelos.data);
      });

    /*     if (!localStorage.getItem("yavistioelsitio")) {
      localStorage.setItem("yavistioelsitio", "true");
    } */
  }, []);

  const [loader, setLoader] = useState(true);

  const delayProgressBar = () => {
    setTimeout(() => setLoader(false), 2000);

    return loader ? (
      <div class="progress grey lighten-3">
        <div class="indeterminate grey"></div>
      </div>
    ) : (
      <h4>
        Actualmente no contamos con disponibilidad para entrega inmediata.
      </h4>
    );
  };

  const sliders = () => {
    var links =
      modelos.length > 0 ? (
        modelos.map((modelo, i) => {
          return (
            <Slider
              key={i}
              modelo={modelo.modelo}
              onSeleccionVehiculo={actualizarVehiculoSeleccionado}
              /* descuentos={descuentos} */
            />
          );
        })
      ) : (
        <div className="row">
          <div
            className="col s6 offset-s3 center"
            style={{ paddingTop: "25px", paddingBottom: "25px" }}
          >
            {delayProgressBar()}
          </div>
        </div>
      );
    return links;
  };

  const rutas = () => {
    var routes = modelos.map((modelo, i) => {
      return (
        <Route key={i} path={"/" + modelo.modelo}>
          <ContenedorTarjetas
            modelos={modelos}
            modelo={"/" + modelo.modelo}
            onSeleccionVehiculo={actualizarVehiculoSeleccionado}
            /* descuentos={descuentos} */
          />
        </Route>
      );
    });
    return routes;
  };

  let seccion = "0km Cero Vueltas";

  const descuentos = useContext(uiContext);

  return (
    <div>
      {mostrarModal && <ModalVideo handleMostrarModal={handleMostrarModal} />}

      {/* <Router basename={"/"}> */}
      <Router basename={"/vtf"}>
        {resultadoReserva && <Redirect to="/resultado_reserva" />}

        <Switch>
          {rutas()}

          <Route path="/contacto">
            <Contacto modelos={modelos} />
          </Route>

          <Route path="/reserva">
            <Reserva
              vehiculo={vehiculoSeleccionado}
              modelos={modelos}
              gastos={gastosSeleccionados}
              onHandleReservar={handleReservar}
              onHandleComprobante={handleComprobante}
              handleMostrarModal={handleMostrarModal}
              /* descuentos={descuentos} */
            />
          </Route>

          <Route path="/gastos">
            <Gastos
              vehiculo={vehiculoSeleccionado}
              modelos={modelos}
              onGastoSeleccionado={handleOnGastoSeleccionado}
              handleMostrarModal={handleMostrarModal}
              /* descuentos={descuentos} */
            />
          </Route>

          <Route path="/resultado_reserva">
            <ResultadoReserva
              modelos={modelos}
              resultado={resultadoReserva}
              comprobante={comprobante}
            />
          </Route>

          <Route path="/">
            <Header modelos={modelos} handleMostrarModal={handleMostrarModal} />
            {sliders()}
          </Route>
        </Switch>

        <div className="center-align">
          <p>
            <i>
              Precios válidos únicamente para realizar una reserva online y de
              contado. Exenta está la posibilidad de financiación y/o permuta.
              Para más información 4505-8700 o ventas@prana.com.ar
            </i>
          </p>
        </div>
        <footer className="page-footer homeFooter">
          <div className="container">
            <div className="row">
              <div className="col l12 s12 center-align">
                <a
                  /*onClick={scrollTop}*/ href={`https://wa.me/5491145058700?text=Hola, me estoy comunicando desde las seccion ${seccion}. Mi consulta es:%20`}
                >
                  {/*<i className="material-icons white-text circle white-text right" style={{background : "red", fontSize : "4em"}}>phone</i>*/}

                  {/* <div className="col l6 m6 s8 left-align" style={{paddingLeft : '0px'}}> */}
                  <div className="col l12 m12 s12">
                    <img
                      src="./images/logos/whatsappSmall.png"
                      style={{ width: "50px" }}
                      alt="whatsapp"
                    ></img>

                    <h5
                      className="grey-text text-lighten-4"
                      style={{ lineHeight: "5px" }}
                    >
                      Contacto
                    </h5>
                    <p className="grey-text text-lighten-4">Click aquí</p>
                    <p
                      className="grey-text text-lighten-4"
                      style={{ lineHeight: "0px" }}
                    >
                      1145058700
                    </p>

                    {/*                   <ul>
                    
                    
                    <li className="grey-text text-lighten-4 left-align" style={{marginLeft : "15px"}}>click aqui</li>
                    {/*<li className="grey-text text-lighten-4 left-align">011-4505-8604</li>
                    <li className="grey-text text-lighten-4 left-align">Lun a Vie 8:30 a 19:30hs</li>
                  </ul> */}
                  </div>
                  {/* </div> */}
                </a>
              </div>
            </div>
          </div>
          <div className="footer-copyright homeFooter center-align">
            <div className="container">© 2023 Copyright Clama S.A.</div>
          </div>
        </footer>
      </Router>
    </div>
  );
}

export default App;
